import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
//懒加载路由方式
const newsHome = r => require.ensure([], () => r(require('../views/newsHome/index.vue')), 'newsHome')
const search = r => require.ensure([], () => r(require('../views/search/index.vue')), 'search')
const articleDetail = r => require.ensure([], () => r(require('../views/articleDetail/index.vue')), 'articleDetail')
const allReply = r => require.ensure([], () => r(require('../views/allReply/index.vue')), 'allReply')
const labelPage = r => require.ensure([], () => r(require('../views/labelPage/index.vue')), 'labelPage')
const authorized = r => require.ensure([], () => r(require('../views/appAuthorView/authorized/authorized.vue')), 'authorized')
const erCode = r => require.ensure([], () => r(require('../views/appAuthorView/erCode/erCode.vue')), 'erCode')
const healthAuthorized = r => require.ensure([], () => r(require('../views/appAuthorView/healthAuthorized/healthAuthorized.vue')), 'healthAuthorized')
export default new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '*', //默认推荐路由
      redirect: '/newsHome',
      meta:{
        index:0
      }
    },
    {
      path: '/recommend', //默认推荐路由
      redirect: '/newsHome',
      meta:{
        index:0
      }
    },
    {
      path: '/newsHome', //资讯首页
      component: newsHome,
      meta:{
        index:0
      }
    },
    {
      path: '/search', //搜索页
      component: search,
      meta:{
        index:1
      }
    },
    // {
    //   path: '/articleDetail/:id', //文章详情页
    //   component: articleDetail,
    //   meta:{
    //     index:1
    //   }
    // },
    {
      path: '/articleDetail', //文章详情页
      component: articleDetail,
      meta:{
        index:1
      }
    },
    {
      path: '/allReply', //全部评论页
      component: allReply,
      meta:{
        index:2
      }
    },
    {
      path: '/labelPage', //标签跳转页
      component: labelPage,
      meta:{
        index:2
      }
    },
    { //授权页
      path: '/authorized',
      component: authorized,
      meta:{
        index:2
      }
    },
    { //微信二维码页
      path: '/erCode',
      component: erCode,
      meta:{
        index:3
      }
    },
    { //授权页
      path: '/healthAuthorized',
      component: healthAuthorized,
      meta:{
        index:3
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js